import { cloneDeep } from 'lodash-es'

import type { OrderStore } from 'Stores/orderStore/orderStore'

import type { OrderDevice } from 'Portal/src/mappers/orderDeviceMapper/orderDevice.types'

interface NetPriceDevice {
  rentCategoryId: number
  calculatedNet: number
}

const applyNetPrices = (
  devices: OrderDevice[],
  netPrices: NetPriceDevice[],
): OrderDevice[] =>
  devices.map(device => {
    const netPrice = netPrices.find(
      ({ rentCategoryId }) =>
        Number(rentCategoryId) === Number(device.rentCategoryId),
    )

    if (!netPrice) {
      return device
    }

    const updated = cloneDeep(device)

    updated.calculatedNet = netPrice.calculatedNet

    return updated
  })

export const calculateNetPrices = (orderStore: OrderStore) => {
  const {
    accessories,
    orderDevices,
    netPriceCalculator,
    setAccessories,
    setOrderDevices,
  } = orderStore

  fetch(`${window.GO_API_URL}/net-price-calculator`, {
    body: JSON.stringify({
      accessories: accessories?.map(accessory => ({
        copaymentNet: accessory.copaymentNet,
        rentCategoryId: accessory.rentCategoryId,
      })),
      childAllowance: netPriceCalculator.childAllowanceValue,
      churchTax: !!netPriceCalculator.churchTaxValue,
      devices: orderDevices?.allDevices?.map(device => ({
        copaymentNet: device.copaymentNet,
        rentCategoryId: device.rentCategoryId,
      })),
      healthContribution: +netPriceCalculator.healthValue,
      salary: +netPriceCalculator.salaryValue,
      state: netPriceCalculator.stateValue,
      taxClass: netPriceCalculator.taxClassValue,
    }),
    method: 'POST',
  })
    .then(response => response.json())
    .then(
      (response: {
        netPriceDevices: NetPriceDevice[]
        netPriceAccessories: NetPriceDevice[]
      }) => {
        if (orderDevices) {
          setOrderDevices({
            allDevices: orderDevices.allDevices
              ? applyNetPrices(
                  orderDevices.allDevices,
                  response.netPriceDevices,
                )
              : null,
            groupedDevices:
              orderDevices.groupedDevices?.map(group => ({
                ...group,
                devices: applyNetPrices(
                  group.devices,
                  response.netPriceDevices,
                ),
              })) || null,
            variant: orderDevices.variant,
          })
        }

        setAccessories(
          accessories
            ? applyNetPrices(accessories, response.netPriceAccessories)
            : null,
        )
      },
    )
}
